import _Comment from './Comment';

import './style/index.js';

export type { CommentProps } from './Comment';
export * from './type';

export const Comment = _Comment;

export default Comment;
